import { XIcon } from "@heroicons/react/outline";
import { MouseEventHandler } from "react";

const CloseButton = ({
  onClick,
}: {
  onClick?: MouseEventHandler<HTMLButtonElement>;
}) => {
  return (
    <button
      type="button"
      className="bg-white rounded-sm p-1 text-gray-500 hover:text-gray-800 hover:bg-gray-100"
      aria-label="Close"
      onClick={onClick}
    >
      <span className="sr-only">Close</span>
      <XIcon className="h-6 w-6" />
    </button>
  );
};

export default CloseButton;
